import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
export type TaskItem = {
  id: string;
  label: string;
  due: string;
  done: boolean;
  owner?: string;
};
type TaskListProps = {
  tasks: TaskItem[];
  emptyLabel?: string;
};
export function TaskList({
  tasks,
  emptyLabel = 'No open tasks.'
}: TaskListProps) {
  const [completed, setCompleted] = useState<string[]>(tasks.filter(task => task.done).map(task => task.id));
  const toggle = (id: string) => setCompleted(prev => prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]);
  if (tasks.length === 0) {
    return <p className="text-[12.5px] text-gray-500" data-id="element-225" data-mp="1jgp0hry1h2gp">{emptyLabel}</p>;
  }
  return <ul className="space-y-2" data-id="element-226" data-mp="1ohcrweq6jlbg">
      {tasks.map(task => {
      const done = completed.includes(task.id);
      const overdue = task.due.toLowerCase() === 'overdue';
      return <li key={task.id} data-id="element-227" data-mp="2zvqdte1dhqou">
            <label className="flex cursor-pointer items-center gap-3 rounded-lg border border-gray-200 px-3 py-2.5 transition-colors hover:bg-gray-50" data-id="element-228" data-mp="2zux90ilz5b9c">
              <input type="checkbox" className="sr-only" checked={done} onChange={() => toggle(task.id)} data-id="element-229" data-mp="3j0trma83ex47" />
              <span aria-hidden="true" className={['flex h-4 w-4 shrink-0 items-center justify-center rounded border', done ? 'border-success bg-success text-white' : 'border-gray-300 bg-white'].join(' ')} data-id="element-230" data-mp="3e3ti1pc1bc8c">
                {done && <CheckIcon className="h-3 w-3" data-id="element-231" data-mp="2vb8y4xebchgo" />}
              </span>
              <span className="min-w-0 flex-1" data-id="element-232" data-mp="2v94tueci5gfv">
                <span className={['block truncate text-[13px]', done ? 'text-gray-400 line-through' : 'text-ink'].join(' ')} data-id="element-233" data-mp="2qcxlkewmvsur">
                  {task.label}
                </span>
                {task.owner && <span className="text-[11.5px] text-gray-500" data-id="element-234" data-mp="26pb6m88razqk">{task.owner}</span>}
              </span>
              <span className={['shrink-0 text-[11.5px] font-medium', overdue ? 'text-danger' : 'text-gray-500'].join(' ')} data-id="element-235" data-mp="2br0l5xv6tvje">
                {task.due}
              </span>
            </label>
          </li>;
    })}
    </ul>;
}